<div class="paypal-donation-container">
    <h3 [translate]="'paypal_donation.pay_with'"></h3>
    <img src="images/paypal.png" alt="---paypal.png---" title="" />
    <br />
    <br />
    <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="{{hostedButtonId}}" />
        <input
            type="image"
            src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
            border="0"
            name="submit"
            title="{{'paypal_donation.image_title'|translate}}"
            alt="---paypalbutton---" />
        <img
            border="0"
            src="https://www.paypal.com/en_US/i/scr/pixel.gif"
            width="1"
            height="1"
            alt="---pixel.gif---"
            title="" />
    </form>
</div>
